export const ReadOnlyLockIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.25 9H13.75V8C13.75 7.0335 12.9665 6.25 12 6.25C11.0335 6.25 10.25 7.0335 10.25 8V9ZM9 9H8C7.44772 9 7 9.44772 7 10V16C7 16.5523 7.44772 17 8 17H16C16.5523 17 17 16.5523 17 16V10C17 9.44772 16.5523 9 16 9H15V8C15 6.34315 13.6569 5 12 5C10.3431 5 9 6.34315 9 8V9Z"
      fill="#171C2E"
      fill-opacity="0.8"
    />
  </svg>
);